<template>
  <div class="receptionPage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="recApply.applicantIdName"
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <!-- 所属项目 -->
    <van-cell-group class="itemPerson baseNone beizhu moreText">
      <van-field
        v-model="recApply.projectName"
        :required="editType"
        type="textarea"
        label="所属项目："
        :placeholder="editType ? '请选择' : ''"
        @click="checkItemPicker"
        :is-link="editType"
        readonly
        rows="1"
        autosize
      />
    </van-cell-group>
    <!-- 随行人员 -->
    <van-cell-group class="itemPerson baseNone beizhu moreText">
      <van-field
        v-model="recApply.participantNames"
        :required="editType"
        readonly
        type="textarea"
        label="接待参与人员："
        :placeholder="editType ? '请选择' : ''"
        @click="checkRetinuePicker"
        :is-link="editType"
        rows="1"
        autosize
      />
    </van-cell-group>
    <!-- 接待对象 -->
    <van-cell-group class="baseNone">
      <van-field
        v-model="recApply.receptionUsers"
        :required="editType"
        :readonly="editType == true ? false : true"
        label="接待对象："
        :placeholder="editType ? '请输入...  ' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <!--  -->
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="recApply.receptionTime"
        :required="editType"
        readonly
        label="接待时间："
        :placeholder="editType ? '请选择' : ''"
        @click="TimePicker"
        :is-link="editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu moreText">
      <van-field
        v-model="isFixedPointName"
        :required="editType"
        readonly
        label="是否定点就餐："
        :placeholder="editType ? '请选择' : ''"
        @click="isFixedPointPickershow = true"
        :is-link="editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary" v-if="restaurantShow">
      <van-field
        v-model="recApply.restaurantName"
        :required="editType"
        readonly
        label="就餐饭店："
        :placeholder="editType ? '请选择' : ''"
        @click="restaurantPickerShow = true"
        :is-link="editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="recApply.reason"
        rows="1"
        autosize
        :required="editType"
        label="接待内容："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="editType == true ? false : true"
      />
    </van-cell-group>

    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="recApply"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :filesData="recApply"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>
    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && recApply.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="recApply"></audit-list>
    </div>
    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && recApply.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="recApply"></flow-staff>
      <flow-list :workflowCode="recApply.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="recApply"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="recApply.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="recApply.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        recApply.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          recApply.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          recApply.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出层 -->
    <!--  随行人员管理 -->
    <van-popup v-model="showRetinuePicker" position="bottom" class="roleBox">
      <retinue-view
        :retinueUids="recApply.participants"
        @setReview="setRetinue"
      ></retinue-view>
    </van-popup>
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <!-- 是否定点就餐 -->
    <van-popup v-model="isFixedPointPickershow" position="bottom">
      <van-picker
        show-toolbar
        :columns="isFixedPointList"
        value-key="dictName"
        @cancel="isFixedPointPickershow = false"
        @confirm="saveFixedPoint"
      />
    </van-popup>
    <!-- 饭店列表-->
    <van-popup v-model="restaurantPickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="restaurantList"
        value-key="dictName"
        @cancel="restaurantPickerShow = false"
        @confirm="saveRestaurant"
      />
    </van-popup>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPagePicker" />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const retinueView = () => import("@/components/businessTripMould/retinueView");
const projectView = () => import("@/components/businessTripMould/projectView");
import { dateTimeFormat, isEdit, getDictList } from "@/utils/common";

import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
export default {
  name: "receptionApply",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      refreshPagePicker: false,
      editTypeName: "撤回",
      recApply: {
        id: "",
        applicantId: "", //申请人id
        applicantIdName: "", //申请人姓名
        projectId: "", //项目编号
        projectName: "", //项目名称
        participants: [], //随行人员id
        participantNames: "", //随行人员姓名
        receptionUsers: "", //接待人员
        receptionTime: "", //接待时间
        isFixedPoint: false, //是否定点就餐
        restaurant: "", //就餐饭店
        restaurantName: "", //就餐饭店名称
        reason: "", //接待内容
        verifyStatus: "hold", //详情的当前状态
        baseAnnexes: [], //附件
      },
      restaurantShow: false,
      isFixedPointPickershow: false, //是否定点就餐
      isFixedPointName: "",
      isFixedPointList: [
        { dictName: "是", value: true },
        { dictName: "否", value: false },
      ],
      restaurantPickerShow: false, //就餐饭店弹框
      restaurantList: [], //就餐饭店列表
      retinueUids: "", //传递子组件姓名
      showRetinuePicker: false, //随行人员弹框
      showItemPicker: false, //所属项目弹框
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      clientType: getDeviceType(), //手机内型
      mode: "add",
      editType: false, //能否编辑
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      sendType: "", //判断是否在抄送列表
      is_weixn: is_wei(), //是否为微信
    };
  },
  components: {
    retinueView,
    projectView,
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  mounted() {
    if (is_wei()) {
      document.title = "接待申请";
    }
    window.editPage = this.editPage; //编辑页面
    window.verifyPage = this.verifyPage; //审批页面

    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      this.getRestaurantList(); //获取就餐饭店列表
      if (this.userinfo && this.userinfo.id) {
        this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
        this.recApply.applicantIdName =
          this.mode == "add" ? this.userinfo.realName : "";
        this.recApply.applicantId = this.mode == "add" ? this.userinfo.id : "";
      }
      this.mode !== "add"
        ? this.commonId
          ? this.getDetails()
          : this.$toast("未获取到当前申请id")
        : "";
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },

    async getRestaurantList() {
      this.restaurantList = await getDictList("hotelType "); //字典项接口获取饭店列表
      console.log(this.reasonTypeList, "this.reasonTypeList");
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.$api.administration.administration.reception
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.recApply = res.data;

            _this.isFixedPointName = _this.recApply.isFixedPoint ? "是" : "否";
            _this.restaurantShow = _this.recApply.isFixedPoint;

            if (
              (_this.recApply.verifyStatus == "hold" ||
                _this.recApply.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
            // _this.editPage()
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast(err);
        });
    },
    /*点击随行人员,弹出随行人员组件*/
    checkRetinuePicker() {
      if (this.editType) {
        this.showRetinuePicker = true;
      }
    },
    /*获取人员信息*/
    setRetinue(data) {
      if (data != "") {
        this.recApply.participantNames = data.names;
        this.recApply.participants = data.ids;
      }
      this.showRetinuePicker = false;
    },
    /*显示所属项目控件*/
    checkItemPicker() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    /*获取所属项目数据*/
    setProject(data) {
      if (data != "") {
        this.recApply.projectId = data.id;
        this.recApply.projectName = data.name;
      }
      this.showItemPicker = false;
    },
    /*点击接待时间控件*/
    TimePicker() {
      if (this.editType) {
        this.showTimePicker = true;
      }
    },
    /*接待时间确认回调*/
    onTimeConfirm(data) {
      this.showTimePicker = false;
      this.recApply.receptionTime = dateTimeFormat(data);
    },
    // 是否定点就餐
    saveFixedPoint(data) {
      this.recApply.isFixedPoint = data.value;
      this.isFixedPointName = data.dictName;

      if (data.value) {
        this.restaurantShow = true;
      } else {
        this.restaurantShow = false;
      }
      this.isFixedPointPickershow = false;
    },
    //选择饭店就餐列表
    saveRestaurant(data) {
      this.recApply.restaurant = data.dictCode;
      this.recApply.restaurantName = data.dictName;
      this.restaurantPickerShow = false;
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.recApply.baseAnnexes = data;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      console.log(JSON.stringify(_this.recApply));
      /*校验必填地段*/
      if (_this.recApply.isFixedPoint) {
        if (
          _this.recApply.participants &&
          _this.recApply.participants.length > 0 &&
          _this.recApply.projectId &&
          _this.recApply.receptionUsers &&
          _this.recApply.receptionTime &&
          _this.recApply.reason &&
          _this.recApply.restaurant
        ) {
          _this.mode = msg;
          _this.saveAll();
        } else {
          _this.$toast("带星号为必填，不能为空");
        }
      } else {
        if (
          _this.recApply.participants &&
          _this.recApply.participants.length > 0 &&
          _this.recApply.projectId &&
          _this.recApply.receptionUsers &&
          _this.recApply.receptionTime &&
          _this.recApply.reason
        ) {
          _this.mode = msg;
          _this.saveAll();
        } else {
          _this.$toast("带星号为必填，不能为空");
        }
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.administration.administration.reception
        .recSave(_this.mode, _this.recApply)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
          _this.btnLoading = false;
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.recApply.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.administration.administration.reception
            .operate(_this.recApply.verifyStatus, _this.recApply.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，请稍后重试");
              _this.btnLoading = false;
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
          this.recApply.applicantIdName =
            this.mode == "add" ? this.userinfo.realName : "";
          this.recApply.applicantId =
            this.mode == "add" ? this.userinfo.id : "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.receptionPage {
  width: 100%;
  // height: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }

  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 140px;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
  //审批操作样式
}
</style>